import { registerApp } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { createStore } from 'stores';
import { createEntry, getInitialData } from '../common';

function createApplication() {
  const router = getGlobalRouter();
  const preloadedState = getInitialData();

  const { store } = createStore({
    router,
    preloadedState,
    host: window.location.host,
    cookie: document.cookie,
    userAgent: window.navigator.userAgent,
  });

  return createEntry({ store, router, remoteContext: undefined });
}

registerApp(__NAME__, createApplication);
